import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerImageWithWrappingConverter extends CmsConverterService<ColorContainerImageWithWrappingData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      headline: formData.st_headline ?? defaultTextInput,
      alignImage: formData.st_align_image?.value?.identifier ?? 'right',
      text: formData.st_text ?? defaultTextInput,
      overlayCaption: formData.st_caption_overlay ?? defaultTextInput,
      overlayDescription: formData.st_description_overlay ?? defaultTextInput
    }
  }
}

export const COLOR_CONTAINER_IMAGE_WITH_WRAPPING_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerImageWithWrappingData>>('ColorContainerImageWithWrappingConverter')

export interface ColorContainerImageWithWrappingData extends ConvertedComponentData {
  image: Image;
  headline: TextInput;
  alignImage: string;
  text: TextInput;
  overlayCaption: TextInput;
  overlayDescription: TextInput;
}
